export default __webpack_public_path__ + "static/media/nodedotjs.6d0ce605.svg";